import React, { useContext } from 'react'

import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import SoftButton from 'components/SoftButton'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'
import { IntakeContext } from 'context/IntakeContext'
import Slide from '@mui/material/Slide'
import { toast } from 'react-toastify'
import { useFormDebounce } from 'hooks/useFormDebounce'
import styled, { keyframes } from 'styled-components'
import LoopIcon from '@mui/icons-material/Loop'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const rotatingIcon = keyframes`
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
`
const colorChangeIcon = keyframes`
  0% {
    color: #66d432;
  }
  50% {
    color: #66d432;
  }
  100% {
    color: #344767;
  }
`
const ChangesSavedIcon = styled(CheckCircleOutlineIcon)`
  &.saved {
    color: #344767;
    font-size: 1.5rem !important;
    animation: 2s ${colorChangeIcon} ease-out;
  }
`
const SavingIcon = styled(LoopIcon)`
  &.loading {
    color: #344767;
    font-size: 1.5rem !important;
    animation: 1.5s ${rotatingIcon} linear infinite;
  }
`

export const UpdateRetirementFieldModalForm = ({ handleClose, open }) => {
  const {
    reloadUser,
    intakeState,
    updateIntakeStateAtKey,
    updateUser,
    currentErrors,
  } = useContext(IntakeContext)

  const { updateIntakeStateAndSubmit, loading } = useFormDebounce()

  const onSubmit = async () => {
    await updateUser()
    toast.info('You have successfully updated your Retirement Date', {
      position: 'top-center',
      autoClose: 5000,
      pauseOnFocusLoss: false,
      pauseOnHover: false,
    })
  }

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {'Change Retirement Date'}
        <Button
          variant="gradient"
          color="dark"
          sx={{ height: '100%', padding: '6px 12px' }}
          onClick={onSubmit}
          startIcon={
            loading ? (
              <>
                <SavingIcon fontSize="medium" className={'loading'} />
              </>
            ) : (
              <>
                <ChangesSavedIcon fontSize="medium" className={'saved'} />
              </>
            )
          }
        >
          {loading ? `updating...` : 'up to date'}
        </Button>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {renderMuiFormField({
              autoFocus: false,
              id: 'dateOfPlannedRetirement',
              label: 'When do you plan on retiring?',
              inputType: 'date',
              value: intakeState.dateOfPlannedRetirement,
              onChange: updateIntakeStateAndSubmit((dateOfPlannedRetirement) =>
                updateIntakeStateAtKey({ dateOfPlannedRetirement })
              ),
            })}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <SoftButton variant="text" color="dark" onClick={handleClose}>
          Close
        </SoftButton>
        {/* <SoftButton
          variant="gradient"
          color="dark"
          sx={{ height: '100%' }}
          onClick={onSubmit}
        >
          Save
        </SoftButton> */}
      </DialogActions>
    </Dialog>
  )
}
